<!--
 * @Description: 
 * @Date: 2020-09-27 15:50:52
 * @LastEditors: jml
-->
<template>
  <div class="share">
    <div class="share-info">微信右上角转发或复制以下链接邀请</div>
    <div class="url">
      <span>{{url}}</span>
      <div class="btn" v-copy="url" :data-url="url">复制</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { game } from '../..//mixins/game';
export default {
  data() {
    return { url: '' };
  },
  mixins: [game],
  computed: {
    ...mapState({
      info: state => state.game.info
    })
  },
  methods: {},
  mounted() {
    this.setShareUrl();
  }
};
</script>
<style lang="less" scoped>
.share {
  width: 100%;
  .share-info {
    font-size: 0.32rem;
    line-height: 1;
    color: #ffd7d1;
    padding-left: 0.2rem;
  }
  .url {
    background-color: #ffabb4;
    margin-top: 0.1rem;
    position: relative;
    height: 1rem;
    line-height: 1rem;
    padding-left: 0.1rem;
    font-size: 0.32rem;
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
    overflow: hidden;
    .btn {
      position: absolute;
      background-color: #5b0c15;
      width: 1.5rem;
      height: calc(100% + 4px);
      right: -1px;
      top: -1px;
      color: #ffabb4;
      text-align: center;
      padding-left: 0.1rem;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
    }
  }
}
</style>